import MasterList from "./MasterList";

export function Contractors() {
  return (
    <MasterList
      resource="contractors"
      title="Contractors"
      exportName="contractors"
      columns={[
        { key: "contractor_code", label: "Code" },
        { key: "name", label: "Name" },
        { key: "skill_type", label: "Skill" },
        { key: "contact_person", label: "Contact" },
        { key: "phone", label: "Phone" },
        { key: "gst_number", label: "GST" },
      ]}
      defaultRecord={{ contractor_code: "", name: "", contact_person: "", phone: "", email: "", address: "", gst_number: "", pan: "", skill_type: "General", bank_details: "", opening_balance: 0 }}
      formFields={[
        { key: "contractor_code", label: "Contractor Code", required: true },
        { key: "name", label: "Name", required: true },
        { key: "skill_type", label: "Skill Type", type: "select", options: ["General", "Civil", "Electrical", "MEP", "Solar", "Fire Fighting", "IFMS", "MMG"] },
        { key: "contact_person", label: "Contact Person" },
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email" },
        { key: "gst_number", label: "GST Number" },
        { key: "pan", label: "PAN" },
        { key: "opening_balance", label: "Opening Balance", type: "number" },
        { key: "address", label: "Address", type: "textarea", full: true },
        { key: "bank_details", label: "Bank Details", type: "textarea", full: true },
      ]}
    />
  );
}

export function Members() {
  return (
    <MasterList
      resource="members"
      title="Members"
      exportName="members"
      bulkUploadMaster="members"
      bulkUploadFilename="members_master_template.xlsx"
      bulkUpdate={{
        templateEndpoint: "/members/bulk-update-template",
        uploadEndpoint: "/members/bulk-update",
        filename: "members_bulk_update_template.xlsx",
      }}
      bulkAssignBranch={{
        countEndpoint: "members-branchless-count",
        applyEndpoint: "members-bulk-set-branch",
      }}
      activeField="active"
      columns={[
        { key: "member_code", label: "Code" },
        { key: "name", label: "Name" },
        { key: "designation", label: "Designation" },
        { key: "department", label: "Department" },
        { key: "branch_name", label: "Branch" },
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email" },
      ]}
      defaultRecord={{ member_code: "", name: "", designation: "", department: "", phone: "", email: "", join_date: "", active: true }}
      formFields={[
        { key: "member_code", label: "Member Code", required: true },
        { key: "name", label: "Name", required: true },
        { key: "designation", label: "Designation" },
        { key: "department", label: "Department" },
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email" },
        { key: "join_date", label: "Join Date", type: "date" },
      ]}
    />
  );
}
